import config from 'config/appConfig';
import { DivConst } from 'constants/divConst';
import { isEmpty, isNotEmpty, formatTimeToDate } from 'utils/app';

/**
 * クイズのプレビューURLを取得します。
 */
export function getPreviewUrl(quizPreviewCd: string): string {
  return `${config.url.userWeb}/quiz/preview/${quizPreviewCd}`;
}

/**
 * クイズのプレビューURLを開きます。
 */
export function openPreviewUrl(quizPreviewCd: string): void {
  window.open(getPreviewUrl(quizPreviewCd), '_blank');
}

/**
 * クイズの公開URLを取得します。
 */
export function getProductionUrl(quizCd: string): string {
  return `${config.url.userWeb}/quiz/${quizCd}`;
}

/**
 * クイズの公開URLを開きます。
 */
export function openProductionUrl(quizCd: string): void {
  window.open(getProductionUrl(quizCd), '_blank');
}

/**
 * クイズのLINE公開URLを取得します。
 */
export function getLineProductionUrl(quizCd: string): string {
  return `${config.url.userWeb}/quiz/line/${quizCd}`;
}

/**
 * クイズのLINE公開URLを開きます。
 */
export function openLineProductionUrl(quizCd: string): void {
  window.open(getLineProductionUrl(quizCd), '_blank');
}

/**
 * 公開期間の文字列を作成します。。
 * こうかい予定日よりも公開日を優先して表示します。
 */
export function formatPublishTerm(props: {
  quizStatusDiv: number;
  publishStartAt: number;
  publishEndAt: number;
  publishedAt: number;
  terminatedAt: number;
}): string {
  // eslint-disable-next-line no-useless-assignment -- 後続の条件分岐で上書きされるため初期値としてnullを設定
  let startAt = null;
  // eslint-disable-next-line no-useless-assignment -- 後続の条件分岐で上書きされるため初期値としてnullを設定
  let endAt = null;

  // 予約ステータスの場合は、予約日を優先
  if (props.quizStatusDiv == DivConst.items.quizStatus.reserved.value) {
    startAt = props.publishStartAt;
    endAt = props.publishEndAt;
  }
  // その他のステータスの場合は、公開実績を優先
  else {
    startAt = isNotEmpty(props.publishedAt) ? props.publishedAt : props.publishStartAt;

    endAt = isNotEmpty(props.terminatedAt) ? props.terminatedAt : props.publishEndAt;
  }

  if (isEmpty(startAt) && isEmpty(endAt)) {
    return '指定なし';
  }
  if (isEmpty(startAt) && isNotEmpty(endAt)) {
    return `${formatTimeToDate(new Date().getTime(), 'yyyy/MM/dd')} 〜 ${formatTimeToDate(endAt, 'yyyy/MM/dd')}`;
  }
  if (isNotEmpty(startAt) && isEmpty(endAt)) {
    return `${formatTimeToDate(startAt, 'yyyy/MM/dd')} 〜 無期限`;
  }

  return `${formatTimeToDate(startAt, 'yyyy/MM/dd')} 〜 ${formatTimeToDate(endAt, 'yyyy/MM/dd')}`;
}
